/* eslint-disable max-len */
import PropTypes from 'prop-types';
import FormDialog from '../../../Components/Modal/modal';
import { CANCEL_TEXT, STAFF_AUGMENTATION } from '../../../Constants/strings';
import './uploadResumePopUp.scss';

// eslint-disable-next-line max-lines-per-function
const ResumeWatermarkDialog = ({
  openModal,
  handleClose,
  selectedResumeRow,
  onSubmitResumeGenerate,
  isCheckboxChecked,
  setIsCheckboxChecked,
  onCheckboxChange,
  generateResume = false,
}) => {

  const handleCancel = () => {
    setIsCheckboxChecked(true);
    handleClose();
  };

  return (
    <FormDialog
      title={STAFF_AUGMENTATION.RESUME_WATERMARK_TITLE}
      open={openModal}
      button1Action={handleCancel}
      dialogPaperCss="resume-dialog-paper"
      dialogCss="upload-resume-dialog"
      dialogBodycontent={
        <div className="resume-dialog-body">
          <div className="checkbox-wrapper">
            <input
              type="checkbox"
              checked={isCheckboxChecked}
              onChange={(event) => onCheckboxChange(event.target.checked)}
            />
            <label>{generateResume ? STAFF_AUGMENTATION.GENERATE_RESUME_WATERMARK_TEXT : STAFF_AUGMENTATION.CONVERT_RESUME_WATERMARK_TEXT}</label>
          </div>
        </div>
      }
      button1={CANCEL_TEXT}
      button2={STAFF_AUGMENTATION.CONTINUE}
      button2Action={() => onSubmitResumeGenerate(selectedResumeRow)}
      cancelButtonId="resume-popup-cancel-btn"
      submitButtonId="resume-popup-submit-btn"
      dialogButtonsClass="dialog-actions-buttons"
    />
  );
};

ResumeWatermarkDialog.propTypes = {
  openModal: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  selectedResumeRow: PropTypes.object,
  onSubmitResumeGenerate: PropTypes.func.isRequired,
  isCheckboxChecked: PropTypes.bool.isRequired,
  setIsCheckboxChecked: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  generateResume: PropTypes.bool.isRequired,
};

export default ResumeWatermarkDialog;
